import { Pipe, PipeTransform } from '@angular/core';
import { EnumsService } from '../../services';

@Pipe({
  name: 'categoryName'
})
export class CategoryNamePipe implements PipeTransform {
  constructor(private enumService: EnumsService) {}

  transform(value: unknown[]): string {
    if (value.length) {
      return this.enumService.getCategoryName(value);
    }
    return '';
  }
}
